import { VatPriceDTO } from '../../dto';

export class VatPrice {
  priceWithVat: number;
  priceWithoutVat: number;

  constructor(dto: VatPriceDTO) {
    this.priceWithVat = dto.priceWithVat;
    this.priceWithoutVat = dto.priceWithoutVat;
  }

  static fromDto(dto: VatPriceDTO): VatPrice {
    return new VatPrice(dto);
  }
}
